import { App } from 'antd';

const useNotifications = () => {
  const { notification } = App.useApp();

  return { notificationApi: notification };
};

export default useNotifications;
